import { InvoiceResult } from "../../globalHooks/authorizationHooks";
import { axiosHttpClient } from "../../store/GlobalContext";

export const getInvoices = async (): Promise<InvoiceResult[]> => {
  const response = await axiosHttpClient.get(`v1/invoice/all`);
  return response.data;
};
